import { createContext, useContext, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

const LaunchParamsContext = createContext({});

// Bloomreach loads the Widget URL verbatim, so its query string is the only channel into the iframe; expose all of it.
export function LaunchParamsProvider({ children }) {
  const [searchParams] = useSearchParams();
  const value = useMemo(() => {
    const params = {};
    searchParams.forEach((paramValue, key) => {
      params[key] = (paramValue || '').trim();
    });
    return params;
  }, [searchParams]);
  return <LaunchParamsContext.Provider value={value}>{children}</LaunchParamsContext.Provider>;
}

export const useLaunchParams = () => useContext(LaunchParamsContext);
